'use client';

import { useMedia } from 'react-use';

const useIsMobile = () => {
  const isDesktop = useMedia('(min-width: 960px)', false);

  return !isDesktop;
};

export default useIsMobile;
